/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Loading_BookingsInputs */

const en_admin_dashboard_loading_bookings = /** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading bookings…`)
};

const nl_admin_dashboard_loading_bookings = /** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringen laden…`)
};

const ro_admin_dashboard_loading_bookings = /** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se incarca rezervarile...`)
};

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const de_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const es_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const fr_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const it_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const pt_br2_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const pl_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/** @type {(inputs: Admin_Dashboard_Loading_BookingsInputs) => LocalizedString} */
const hu_admin_dashboard_loading_bookings = en_admin_dashboard_loading_bookings;

/**
* | output |
* | --- |
* | "Loading bookings…" |
*
* @param {Admin_Dashboard_Loading_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_loading_bookings = /** @type {((inputs?: Admin_Dashboard_Loading_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Loading_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_loading_bookings(inputs)
	if (locale === "de") return de_admin_dashboard_loading_bookings(inputs)
	if (locale === "es") return es_admin_dashboard_loading_bookings(inputs)
	if (locale === "fr") return fr_admin_dashboard_loading_bookings(inputs)
	if (locale === "nl") return nl_admin_dashboard_loading_bookings(inputs)
	if (locale === "it") return it_admin_dashboard_loading_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_loading_bookings(inputs)
	if (locale === "pl") return pl_admin_dashboard_loading_bookings(inputs)
	if (locale === "hu") return hu_admin_dashboard_loading_bookings(inputs)
	return ro_admin_dashboard_loading_bookings(inputs)
});
export { admin_dashboard_loading_bookings as "admin.dashboard.loading_bookings" }